<template>
  <el-dialog
    title="添加代理配置信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="130px"
      size="small"
    >
      <el-form-item
        prop="title"
        label="标题"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>

      <el-form-item
        prop="agent_sum"
        label="代理商多少个"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.agent_sum"></el-input>
      </el-form-item>
      <el-form-item
              prop="shop_sum"
              label="商家多少个"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.shop_sum"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'smallposterEditForm',
  props: {
    oneclass: Object,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      loading: false,
      dialogVisible: false,

      form: {
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      if (this.oneclass.id) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.title = this.oneclass.title
        form.agent_sum = this.oneclass.agent_sum
        form.shop_sum = this.oneclass.shop_sum

        this.form = form
        // });
        this.formEdit = true
      } else {
        this.formEdit = true
        this.form = {}
      }
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.saveAgentdeploy({ ...this.form, agentid: util.cookies.get('agentid'), xt_id: util.cookies.get('xt_id'), id: this.oneclass.id })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
